import useShared from "../../../../../shared/_common/_shared";

export default function QuorvexEmptyData(props) {
    const {title} = props;
    const {IconCommon} = useShared();

    return (
         <div className={"text-center flex justify-center"}>
            <IconCommon
                isAlwaysInActive
                iconName={"cm-empty-regular"}
                className={"empty-data"}
                title={title || "noData"}
            />
        </div>
    );
}
